import React, { Component } from "react";
import Action from "../../components/Action";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";
import BasicTA10Item from "./BasicTA10Item";
import ShowAddTA10Item from "./ShowAddTA10Item";
import AddTA10Item from "./AddTA10Item";

class TA10Section extends Component {
  constructor(props) {
    super(props);
    this.state = this.initStateFromProps(props);
  }

  initStateFromProps(props) {
    if (props.section) {
      const section = { ...props.section };
      return {
        title: section.title,
        items: section.items,
        errors: section.items.map(() => ({})),
        addItemErrors: {},
      };
    } else {
      const config = this.props.config;
      let items;

      items = config.items.map((item) => {
        return {
          itemName: item.itemName,
          itemType: item.itemType,
          price: "",
        };
      });

      return {
        title: config.sectionTitle,
        items: items,
        itemToAdd: "",
        errors: items.map(() => ({})),
        addItemErrors: {},
      };
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.section !== prevProps.section || this.props.sectionNumber !== prevProps.sectionNumber) {
      this.setState(this.initStateFromProps(this.props));
    }
  }

  validate = () => {
    let validationPassed = true;

    const errors = this.state.items.map((item) => {
      const itemErrors = {};
      if (!item.inclusion) {
        itemErrors.inclusion = true;
        validationPassed = false;
      }
      if (item.itemType === "kitchen" && item.inclusion !== "None" && !item.fitted) {
        itemErrors.fitted = true;
        validationPassed = false;
      }
      if (item.inclusion === "For sale" && !item.price) {
        itemErrors.price = true;
        validationPassed = false;
      }
      return itemErrors;
    });

    this.setState({ errors: errors });

    return validationPassed;
  };

  itemUpdated = (index, item) => {
    const items = [...this.state.items];
    const errors = [...this.state.errors];
    items[index] = item;

    const itemErrors = {};

    if (!item.inclusion) {
      itemErrors.inclusion = true;
    }

    if (item.itemType === "kitchen" && item.inclusion !== "None" && !item.fitted) {
      itemErrors.fitted = true;
    }

    if (item.inclusion === "For sale" && !item.price) {
      itemErrors.price = true;
    }

    errors[index] = itemErrors;
    this.setState({ items: items, errors: errors });
  };

  updateItemToAdd = (name) => {
    this.setState({ itemToAdd: name });
  };

  addItem = () => {
    const newItem = {
      itemName: this.state.itemToAdd,
      itemType: this.props.kitchen ? "kitchen" : "basic",
    };

    this.setState({
      items: [...this.state.items, newItem],
      itemToAdd: "",
      showAddItem: false,
    });
  };

  removeItem = (name) => {
    this.setState({ items: this.state.items.filter((i) => i !== name) });
  };

  showAddItem = () => {
    this.setState({ showAddItem: true });
  };

  undoAddItem = () => {
    this.setState({ showAddItem: false });
  };

  validateItem = (event) => {
    const isBlur = event.type === "blur";
    this.setState((prevState) => {
      const itemToAdd = prevState.itemToAdd;

      const addItemErrors = { ...prevState.addItemErrors };
      const errorMessages = { ...prevState.errorMessages };
      const itemAlreadyExists = prevState.items.some((i) => i["itemName"] === itemToAdd);

      if (isBlur) {
        if (itemAlreadyExists) {
          addItemErrors["itemToAdd"] = true;
          errorMessages["itemToAdd"] = `${itemToAdd} already exists`;
        }
      } else {
        addItemErrors["itemToAdd"] = false;
        errorMessages["itemToAdd"] = null;
      }

      return { addItemErrors, errorMessages };
    });
  };

  saveTA10Section = (event) => {
    event.preventDefault();

    if (this.validate()) {
      const section = {};
      const sectionNumber = this.props.sectionNumber;

      section[`section${sectionNumber}`] = {
        title: this.state.title,
        items: this.state.items,
      };

      this.props.onStepComplete({
        ...section,
      });
    }
  };

  render() {
    const config = this.props.config;

    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title={config.sectionTitle} removeTopPadding>
          {config.sectionNote && <p>{config.sectionNote}</p>}

          {this.state.items.map((item, index) => {
            return (
              <BasicTA10Item
                config={config}
                key={index}
                item={item}
                kitchen={item.itemType === "kitchen" ? true : null}
                removeItem={(item) => this.removeItem(item)}
                onItemUpdate={(item) => this.itemUpdated(index, item)}
                errors={this.state.errors[index] ? this.state.errors[index] : {}}
              />
            );
          })}

          {config.allowsAddItem && !this.state.showAddItem && (
            <ShowAddTA10Item
              onShowAdd={this.showAddItem}
              addLinkText="Add a new item"
              continue={this.saveTA10Section}
            />
          )}

          {config.allowsAddItem && this.state.showAddItem && (
            <AddTA10Item
              question="Add another item"
              value={this.state.itemToAdd}
              valueEntered={this.updateItemToAdd}
              validate={this.validateItem}
              validationError={this.state.addItemErrors["itemToAdd"] ? this.state.errorMessages["itemToAdd"] : null}
              addButtonText="Add item"
              onAdd={this.addItem}
              onCancel={this.undoAddItem}
            />
          )}

          {!config.allowsAddItem && <Action onClick={this.saveTA10Section}>Continue</Action>}
        </Card>
      </React.Fragment>
    );
  }
}

export default TA10Section;
